import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from "@angular/router";
import { Observable } from 'rxjs';
import { switchMap, map, catchError } from 'rxjs/operators';
import { ELearningService } from '../services/e-learning.service';
import { NotificationService } from 'src/app/common/index';


@Injectable()
export class CourseEnrollmentGuard  {

  constructor(private _router: Router,
              private notificationService: NotificationService,
              private eLearningService: ELearningService,) {

  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
    const courseId = route.paramMap.get('id'); // Get the course id from the route
    
    // Return an observable that emits a boolean based on enrollment status
    return this.eLearningService.isUserEnrolledToCourse({courseId: courseId}).pipe(
      map(isEnrolled => {
        if(isEnrolled) {
          return true; // Allow access if the user is enrolled
        } 
        else {
          // Redirect to a page like 'not-enrolled' if the user is not enrolled in the course
          this.notificationService.showErrorHide('First you need to enroll in this course.');
          this._router.navigate(['/error']);
          return false;
        }
      }),
      catchError(() => {
        // Handle error here (in case the request fails)
        this._router.navigate(['/error']);
        return [false]; // Return false if there's an error
      })
    );
  }
}
